import { useNavigate } from "react-router-dom";
import CategoryList from "../../features/manageCategories/categoryList";
import CategoryTopbar from "../../features/manageCategories/topbar";

const ManageCategories = () => {

  const navigate = useNavigate();

  return (
    <>
      <div className="main_title">
        <h1>Manage Service Categories</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Service Categories
        </p>
      </div>
      
      <div className="cards">
        <CategoryTopbar />
        <CategoryList />
      </div>
    </>
  );
};

export default ManageCategories;
